import React from 'react';
import { useHistory } from 'react-router-dom';
import { PrismIcon, PrismLoading, PrismText } from '@prism-ui/react';
import isMobilePage from '../helpers/mobile';
import Xfinity from './svgs/Xfinity';
import XfinityMobile from './svgs/XfinityMobile';

const CustomLoading = () => {
  setTimeout(() => {
    const loadingText = document.querySelector('.loading-text');
    loadingText?.classList.add('loading-text--visible');
  }, 4000);
  const { location } = useHistory();

  const isMobile = isMobilePage(location?.pathname);

  return (
    <div className="loading-main">
      <header className="loading-header">
        {isMobile ? <XfinityMobile /> : <Xfinity />}
      </header>
      <section className="mt-20 mx-auto px-6 max-w-xl">
        <PrismLoading as="icon" size="sm" className="text-brand-primary-base mb-6">
          <PrismIcon display="outline" name="clock" size="lg" tone="primary" />
        </PrismLoading>
        <PrismText family="headline" size="400" className="text-center loading-text">
          Just a moment. This is taking a bit longer than expected, but we&#39;re on it.
        </PrismText>
      </section>
    </div>
  );
};
export default CustomLoading;
